import { defineComponent } from '~/scripts/utils/alpine'

export default defineComponent((options?: { isFirstImage?: boolean }) => ({
  // Track if reveal has already happened
  revealed: false,
  isMobile: window.innerWidth < 1024,
  isFirstImage: options?.isFirstImage || false,

  init() {
    // Add necessary CSS directly to document once
    if (!document.querySelector('#slide-overlay-styles')) {
      const style = document.createElement('style')
      style.id = 'slide-overlay-styles'
      style.textContent = `
        .image-container-wrapper {
          position: relative;
          overflow: hidden;
        }
        .image-container-wrapper::after {
          content: "";
          position: absolute;
          inset: 0;
          background-color: rgba(249, 233, 216, 0.3);
          backdrop-filter: blur(8px);
          transform-origin: left;
          transform: scaleX(1);
          transition: transform 0.7s ease-out;
          z-index: 10;
        }
        .image-container-wrapper.revealed::after {
          transform: scaleX(0);
        }
        .image-container-wrapper.first-image::after {
          transform-origin: right;
          transform: scaleX(1);
        }
        .image-container-wrapper.first-image.revealed::after {
          transform: scaleX(1) translateX(calc(-100% + 6rem));
        }
      `
      document.head.append(style)
    }

    // Check if we're on mobile and add resize listener
    this.isMobile = window.innerWidth < 1024
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth < 1024
      this.updateClasses()
    })

    // Initial class setup
    this.updateClasses()
  },

  updateClasses() {
    const container = this.$el as HTMLElement

    // Only add the effect class on desktop
    if (this.isMobile) {
      container.classList.remove('image-container-wrapper')
      container.classList.remove('revealed')
      container.classList.remove('first-image')
    } else {
      container.classList.add('image-container-wrapper')
      if (this.isFirstImage) {
        container.classList.add('first-image')
      }
    }
  },

  playOverlay() {
    // Skip if on mobile
    if (this.isMobile) return

    // Skip if already revealed once
    if (this.revealed) return

    const container = this.$el as HTMLElement

    // Small delay to ensure the transition is visible
    setTimeout(() => {
      container.classList.add('revealed')
      this.revealed = true
    }, 50)
  },
}))
